const topics = [
  { id: 1, name: '网红翻车', heat: '9.8万', icon: 'ri-alert-line' },
  { id: 2, name: '明星塌房', heat: '8.6万', icon: 'ri-building-2-line' },
  { id: 3, name: '直播乱象', heat: '7.2万', icon: 'ri-live-line' },
  { id: 4, name: '选秀黑幕', heat: '6.5万', icon: 'ri-spy-line' },
  { id: 5, name: '恋情曝光', heat: '5.9万', icon: 'ri-heart-line' },
  { id: 6, name: '综艺大瓜', heat: '5.3万', icon: 'ri-tv-line' },
  { id: 7, name: '带货造假', heat: '4.8万', icon: 'ri-shopping-bag-line' },
  { id: 8, name: '富二代八卦', heat: '4.2万', icon: 'ri-vip-crown-line' },
  { id: 9, name: '经纪公司', heat: '3.6万', icon: 'ri-briefcase-line' },
  { id: 10, name: '资本大瓜', heat: '3.1万', icon: 'ri-funds-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              热门话题
            </h2>
          </div>

          <div className="flex flex-wrap gap-2">
            {topics.map((topic) => (
              <span
                key={topic.id}
                className="inline-flex items-center gap-1.5 px-3.5 py-2 bg-background-50 border border-background-200/60 rounded-full text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className={`${topic.icon} text-xs text-primary-500`}></i>
                {topic.name}
                <span className="text-[10px] text-foreground-400 ml-0.5">{topic.heat}</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}